import { render } from "./site-alert.vue?vue&type=template&id=596cd408"
import script from "./site-alert.vue?vue&type=script&lang=js"
export * from "./site-alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__